module.exports = __webpack_public_path__ + "static/img/watting_icon.bcdd9482.png";